import React, { useState } from 'react';
import './FAQSection.css';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

function FAQSection() {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqs = [
        {
            question: "What will I get after I place the order?",
            answer: (
                <>
                    <p>After you place the order, our representative will call you and confirm the Name, Rasi, and Star. Then we visit the temple and do Archana on behalf of you.</p>
                    <p>You will receive the regarding God's laminated photos and prasad items via courier within</p>
                    <p><strong>Note:</strong> We don't send Coconut, Fruit, and Flower as they are easily composable.</p>
                </>
            )
        },

        {
            question: "When will I get the Archana Prasad?",
            answer: "You will get the Archana Prasad within 7 days max"
        }
    ];

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section className="faq-section">
            <div className="section-inner">
                <h2 className="section-title">Frequently Asked Questions</h2>
                <div className="faq-container">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                            onClick={() => toggleAccordion(index)}
                        >
                            <div className="faq-question">
                                <h3>{faq.question}</h3>
                                <span className="faq-icon">
                                    {activeIndex === index ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                </span>
                            </div>
                            <div className="faq-answer">
                                <div className="faq-answer-content">
                                    {faq.answer}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default FAQSection;
